module.exports = __webpack_public_path__ + "img/calendar.1e6b8072.svg";